import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { WizardService } from '@core/services/wizard/wizard.service';
import { takeUntil } from 'rxjs/operators';
import { DestroyDirective } from '../destroy-abstract/destroy.abstract';
import { numOrZero } from '@core/utils';

@Component({
  selector: 'app-absolute-stepper',
  templateUrl: './absolute-stepper.component.html',
  styleUrls: ['./absolute-stepper.component.scss']
})
export class AbsoluteStepperComponent
  extends DestroyDirective
  implements OnInit, OnChanges
{
  /**
   * numero di step
   */
  @Input() totalSteps: number;

  /**
   * index step attivo
   */
  @Input() activeIndex = 0;

  /**
   * valore della barra
   */
  progress: number;

  constructor(private wizardService: WizardService) {
    super();
  }

  ngOnInit() {
    this.watchWizardAndUpdateProgress();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeIndex || changes.totalSteps) {
      this.updateProgress();
    }
  }

  /**
   * osserva i cambiamenti del wizard
   */
  private watchWizardAndUpdateProgress(): void {
    this.wizardService
      .getWizardWhenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateProgress();
      });
  }

  /**
   * aggiorna il progress
   */
  private updateProgress(): void {
    this.progress = this.calcAbsoluteProgress() + this.calcRelativeProgress();
  }

  /**
   * calcola l'avanzamento rispetto al wizard
   */
  private calcAbsoluteProgress(): number {
    const stepIndex = this.getAbsoluteStepIndex();
    const increment = this.calcAbsoluteIncrement();

    return increment * stepIndex;
  }

  /**
   * calcola l'avanzamento rispetto ai sotto step
   */
  private calcRelativeProgress(): number {
    const stepIndex = this.getRelativeStepIndex();
    const increment = this.calcRelativeIncrement();

    return increment * stepIndex;
  }

  /**
   * calcola l'incremento per i sotto step
   */
  private calcRelativeIncrement(): number {
    const stepsCount = this.getRelativeStepsCount();

    if (stepsCount > 0) {
      return this.calcAbsoluteIncrement() / stepsCount;
    } else {
      return 0;
    }
  }

  /**
   * calcola l'incremento per il wizard
   */
  private calcAbsoluteIncrement(): number {
    const stepsCount = this.getAbsoluteStepsCount();

    if (stepsCount > 0) {
      return 100 / stepsCount;
    } else {
      return 0;
    }
  }

  private getAbsoluteStepIndex(): number {
    return numOrZero(this.wizardService.findActiveStepIndex());
  }

  private getAbsoluteStepsCount(): number {
    return numOrZero(this.wizardService.getWizardSteps().length);
  }

  private getRelativeStepIndex(): number {
    return numOrZero(this.activeIndex);
  }

  private getRelativeStepsCount(): number {
    return numOrZero(this.totalSteps);
  }
}
